import { Form, Row, Col, message, Checkbox, Modal } from "antd";
import React from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { MainImage } from "../../assets/images";
import { PrimaryButton } from "../../component/Button";
import { PasswordInput, TextInput } from "../../component/Input";
import { H3, H4 } from "../../component/Typography";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const termsText = `[Speech4All 이용약관 및 개인정보 수집 및 이용]

제 1 조 (목적)
이 약관은 (주) Speech4All(이하 “회사”)이 제공하는 웹사이트(www.speech4all.kr, 이하 “사이트”) 및 관련 서비스의 이용조건 및 절차, 회사와 회원 간의 권리와 의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.

제 2 조 (정의)
1. “회원”이란 본 약관에 동의하고 사이트에 가입하여 회사가 제공하는 서비스를 이용하는 자를 말합니다.
2. “서비스”란 회사가 제공하는 웹 기반 음성 분석, 언어 평가 자료 관리, 콘텐츠 열람 및 기타 부가 서비스를 의미합니다.
3. “콘텐츠”란 사이트에서 제공하거나 회원이 등록한 텍스트, 이미지, 음성, 영상, 자료 등을 포함한 모든 정보를 말합니다.

제 3 조 (약관의 효력 및 변경)
1. 이 약관은 사이트에 게시하거나 기타 방법으로 회원에게 공지함으로써 효력을 발생합니다.
2. 회사는 관련 법령을 위반하지 않는 범위 내에서 약관을 개정할 수 있으며, 변경된 약관은 제 1 항과 같은 방식으로 효력을 가집니다.
3. 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴를 요청할 수 있습니다.

제 4 조 (회원가입 및 관리)
1. 회원가입은 이용자가 약관에 동의하고 회사가 정한 가입 양식을 작성하여 제출함으로써 이루어집니다.
2. 회사는 다음 각 호에 해당하는 경우 회원가입을 거절하거나 사후에 취소할 수 있습니다.
  ① 타인의 명의 또는 정보를 도용한 경우
  ② 허위 정보를 기재한 경우
  ③ 관련 법령 또는 회사 정책에 위반되는 행위를 한 경우
3. 회원은 가입 시 등록한 정보에 변경이 있는 경우 즉시 수정해야 하며, 미수정으로 인해 발생한 불이익에 대한 책임은 회원에게 있습니다.

제 5 조 (서비스의 제공 및 변경)
1. 회사는 회원에게 다음과 같은 서비스를 제공합니다.
  ① 음성 및 언어 데이터 관리 도구
  ② 자료 처리 및 분석 결과 리포트 제공
  ③ 관련 연구 자료, 교육 콘텐츠 제공
  ④ 기타 회사가 정하는 서비스
2. 회사는 서비스 개선 또는 운영상 필요에 따라 서비스의 내용, 범위 등을 변경할 수 있으며, 변경 시 사전 공지합니다.

제 6 조 (회원의 의무)
1. 회원은 다음 행위를 하여서는 안 됩니다.
  ① 타인의 정보를 무단 사용하거나 도용하는 행위
  ② 회사의 서버, 시스템, 네트워크를 방해하거나 무단 접근하는 행위
  ③ 서비스를 이용하여 불법행위나 영리 목적의 활동을 하는 행위
  ④ 회사 및 제 3자의 저작권 등 지적재산권을 침해하는 행위
2. 회원은 관계 법령, 본 약관 및 이용안내 등 회사가 정한 사항을 준수해야 합니다.

제 7 조 (지적재산권)
1. 회사가 제작하거나 제공하는 콘텐츠(문서, 소프트웨어, 분석자료 등)에 대한 저작권 및 기타 지적재산권은 회사에 귀속됩니다.
2. 회원은 회사의 사전 서면 동의 없이 콘텐츠를 복제, 전송, 배포, 출판, 방송 기타 방법으로 이용하거나 제 3자에게 제공해서는 안 됩니다.
3. 회원이 사이트에 등록한 자료는 회원 본인에게 권리가 있으나, 회사는 서비스 제공을 위해 이를 사용할 수 있는 비독점적 사용권을 가집니다.

제 8 조 (개인정보보호)
1. 회사는 회원의 개인정보를 보호하기 위해 개인정보 보호법 등 관련 법령을 준수합니다.
2. 회사는 회원의 개인정보를 서비스 제공 외 목적으로 사용하지 않으며, 자세한 내용은 [개인정보처리방침]을 따릅니다.

제 9 조 (서비스 이용의 제한 및 중지)
1. 회사는 회원이 본 약관을 위반하거나 다음 각 호에 해당하는 경우 사전 통보 없이 서비스 이용을 제한하거나 회원 자격을 정지/탈퇴시킬 수 있습니다.
  ① 불법적인 목적이나 방법으로 서비스를 이용한 경우
  ② 회사의 명예를 훼손하거나 운영을 방해한 경우
  ③ 기타 서비스 이용자로서 부적절하다고 판단되는 행위
2. 회사는 시스템 점검, 장애, 천재지변 등 불가피한 사유로 일시적 서비스 중단이 가능하며, 이 경우 사전 공지합니다.

제 10 조 (면책조항)
1. 회사는 천재지변, 불가항력, 회원의 고의 또는 과실로 인해 발생한 손해에 대해 책임을 지지 않습니다.
2. 회사는 회원 상호 간 또는 회원과 제 3자 간의 분쟁에서 발생한 문제에 개입하지 않으며, 이로 인해 발생한 손해에 대하여도 책임지지 않습니다.
3. 회사는 서비스에서 제공하는 정보의 정확성이나 신뢰성에 대해 보증하지 않으며, 이로 인한 손해에 대해 책임지지 않습니다.

제 11 조 (준거법 및 관할법원)
본 약관은 대한민국 법률에 따라 해석되며, 서비스 이용과 관련한 회사와 회원 간 분쟁은 회사 본사 소재지 관할 법원을 전속 관할로 합니다.

※ 본 약관은 2025년 4월 18일부터 시행됩니다.

[Speech4All 개인정보 수집 및 이용]

Speech4All(이하 “회사”)는 「개인정보 보호법」 등 관련 법령에 따라 회원님의 개인정보를 안전하게 보호하며, 아래와 같이 개인정보를 수집·이용·보관합니다.

1. 개인정보 수집 항목
- 필수 항목: 성명, 이메일 주소, 비밀번호, 소속 기관 또는 단체명(해당 시), 휴대전화 번호, 가입일시 및 로그인 기록(IP 포함)
- 선택 항목: 생년월일, 직책/직무, 관심 분야 또는 연구 목적
※ 서비스 이용 과정에서 접속 로그, 쿠키, 이용 기록 등 추가 정보가 자동 수집될 수 있습니다.

2. 개인정보 수집 및 이용 목적
- 회원 식별 및 본인 여부 확인
- 서비스 제공 및 맞춤형 콘텐츠 제공
- 연구 또는 교육 목적의 자료 관리 기능 제공
- 고지사항 전달, 고객 상담 및 불만 처리
- 통계 분석 및 서비스 개선
- 법령 또는 약관 위반 시 이용 제한 등 운영 관리

3. 개인정보 보유 및 이용 기간
- 회원 탈퇴 시 또는 수집·이용 목적 달성 시까지 보관
- 단, 관련 법령에 따라 일정 기간 보관할 수 있음
  • 계약 및 청약철회 기록: 5년
  • 접속 기록: 3개월
  • 법적 분쟁 해결 목적 등: 해당 목적 달성 시까지

4. 개인정보의 제3자 제공
회사는 원칙적으로 회원의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 단, 법령에 의하거나 수사기관 요청 시 예외적으로 제공할 수 있습니다.

5. 개인정보 처리 위탁
서비스 제공을 위해 일부 업무를 외부 업체에 위탁할 수 있으며, 이 경우 법령에 따라 안전하게 처리되도록 관리·감독합니다.

6. 이용자의 권리
회원은 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지를 요청할 수 있으며, 탈퇴 시 수집된 개인정보는 지체 없이 파기됩니다.

7. 개인정보 보호책임자 및 문의처
- 책임자: 하승희
- 이메일: gpspeech4all@gmail.com

※ 본 개인정보 수집·이용 안내는 2025년 4월 18일부터 적용됩니다.`;

function OrganizationSignup() {
  const [form] = Form.useForm();
  const isDesktop = useMediaQuery({ query: "(min-width: 576px)" });
  const navigate = useNavigate();

  const [showTermsModal, setShowTermsModal] = React.useState(false);

  const handleSubmit = async (values) => {
    try {
      await axios
        .post(`${process.env.REACT_APP_SERVER_URL}/api/signup`, {
          email: values.email,
          password: values.password,
          name: values.name,
          phone_number: values.phone_number, // 전화번호 추가
          affiliation: values.name, // 일단 기관의 소속은 기관명과 동일하게 설정함
          membership_type: "기관",
        })
        .then((response) => {
          message.success(
            <>
              회원 가입이 완료되었습니다. 사용권 구입은 gpspeech4all@gmail.com로
              연락주세요.
            </>
          );
          navigate("/login"); // 3초 후 로그인 페이지로 이동
        })
        .catch((error) => {
          message.error("회원가입에 실패했습니다.");
        });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        message.error("이미 등록된 이메일입니다.");
      } else {
        message.error("서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
      }
    }
  };

  return (
    <>
      <Row>
        <Col span={isDesktop ? 10 : 0}>
          {isDesktop && (
            <TermsContainer>
              <H3 style={{ marginBottom: "24px" }}>
                이용약관 및 개인정보 수집·이용 안내
              </H3>
              <TermsBox>{termsText}</TermsBox>
            </TermsContainer>
          )}
        </Col>
        <Col span={isDesktop ? 12 : 24}>
          <SignupWrapper>
            <div>이미 계정이 있으신가요?</div>{" "}
            <Login
              onClick={() => {
                navigate("/login");
              }}
            >
              로그인하기
            </Login>
          </SignupWrapper>
          <SignupContainer>
            <H3>기관 회원정보를 입력해주세요.</H3>
            <SignupForm
              form={form}
              name="organization-signup-form"
              initialValues={{ agreement: false }}
              layout={isDesktop ? "vertical" : "horizontal"} // 동적으로 변경
              requiredMark={false}
              onFinish={handleSubmit}
            >
              <SignupItem
                name={"email"}
                rules={[{ required: true, message: "이메일을 입력해주세요!" }]}
                label={<H4>대표 이메일 (아이디)</H4>}
              >
                <TextInput
                  placeholder="이메일을 입력해주세요."
                  type="email"
                  size="large"
                />
              </SignupItem>
              <SignupItem
                name={"password"}
                rules={[
                  { required: true, message: "비밀번호를 입력해주세요!" },
                ]}
                label={<H4>비밀번호</H4>}
              >
                <PasswordInput
                  placeholder="비밀번호를 입력해주세요."
                  size="large"
                />
              </SignupItem>
              <SignupItem
                name={"name"}
                rules={[{ required: true, message: "기관명을 입력해주세요!" }]}
                label={<H4>기관명</H4>}
              >
                <TextInput
                  placeholder="기관명을 입력해주세요."
                  type="text"
                  size="large"
                />
              </SignupItem>
              <SignupItem
                name="phone_number"
                rules={[
                  { required: true, message: "전화번호를 입력해주세요!" },
                ]}
                label={<H4>전화번호</H4>}
              >
                <TextInput
                  placeholder="전화번호를 입력해주세요."
                  type="text"
                  size="large"
                />
              </SignupItem>

              <SignupItem
                name="agreement"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              "이용약관에 동의해야 회원가입이 가능합니다."
                            )
                          ),
                  },
                ]}
              >
                <Checkbox>
                  이용약관 및 개인정보 수집·이용에 동의합니다.
                  {!isDesktop && (
                    <span
                      onClick={() => setShowTermsModal(true)}
                      style={{
                        color: "#1890ff",
                        marginLeft: "8px",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      [약관 보기]
                    </span>
                  )}
                </Checkbox>
              </SignupItem>

              <PrimaryButton
                htmlType="submit"
                type="primary"
                size="large"
                style={{ marginTop: "24px" }}
              >
                회원가입
              </PrimaryButton>
            </SignupForm>
          </SignupContainer>
        </Col>
      </Row>

      {/* ✅ 모바일용 약관 모달 */}
      <Modal
        open={showTermsModal}
        onCancel={() => setShowTermsModal(false)}
        footer={null}
        title="Speech4All 이용약관 및 개인정보 수집·이용"
        width="90%"
        style={{ top: 40 }}
        bodyStyle={{ overflowY: "auto", maxHeight: "70vh" }}
      >
        <TermsBox>{termsText}</TermsBox>
      </Modal>
    </>
  );
}

const SignupContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100vh;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  gap: 36px;
  box-sizing: border-box;
  padding: 80px 16px;
`;

const SignupForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 14px;
`;

const SignupItem = styled(Form.Item)`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 14px;
  margin: 0;
`;

const SignupWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;
  height: 60px;
  padding: 0 24px;
  align-items: center;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 14px;
`;

// const ImageContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 100%;
//   height: 100%;
//   background-image: url(${MainImage});
//   background-size: cover;
//   background-position: center;
// `;

const Login = styled.div`
  position: relative;
  color: var(--fg-primary);
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;
    height: 1px;
    background-color: var(--fg-primary);
    transition: width 0.3s ease-in-out;
  }

  &:hover::after {
    width: 100%;
  }
`;

const TermsContainer = styled.div`
  background-image: url(${MainImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-blend-mode: lighten;
  background-color: rgba(255, 255, 255, 0.85); // 살짝 흐려주기
  padding: 80px 48px;
  overflow-y: auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const TermsBox = styled.div`
  white-space: pre-wrap;
  padding: 16px;
  font-size: 13px;
  background: #f9f9f9;
  border: 1px solid var(--border-component);
  border-radius: 8px;
  line-height: 1.6;
  max-height: 600px;
  overflow-y: auto;
`;

export default OrganizationSignup;
